import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/img/fiveStars.svg';
const _hoisted_1 = {
  class: "g1g__rating pb-5"
};
const _hoisted_2 = {
  class: "rating__content"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 2
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.$route.path == '/' ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "#1 Rated Travel Insurance Company! ")) : _ctx.$route.path == '/visitor' ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _cache[0] || (_cache[0] = [_createTextVNode("#1 rated coverage for visitors to the USA! "), _createElementVNode("img", {
    class: "img-fluid flag-usa",
    height: "10",
    alt: "stars",
    src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/img/us-flag.svg"
  }, null, -1)]))) : (_openBlock(), _createElementBlock("h2", _hoisted_5, "#1 rated coverage by travelers like you!")), _cache[1] || (_cache[1] = _createElementVNode("p", null, "4.9/5 star reviews by travelers", -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "star-container"
  }, [_createElementVNode("img", {
    style: {
      "cursor": "default"
    },
    alt: "",
    src: _imports_0
  })], -1))])]);
}